import { isPlannedClosingDateLessThanThirteenDaysAway } from './isPlannedClosingDateLessThanThirteenDaysAway';

export const isDataValidForPurchaseOrBuild = ({
  city,
  creditScore,
  downPayment,
  hasWaivedEscrow,
  occupancyType,
  isSelfEmployed,
  isUsCitizen,
  isVeteran,
  loanOptions,
  plannedClosingDate,
  price,
  propertyType,
  state,
  street,
  zip,
  county,
}) => {
  const isLessThanThirtyDays = isPlannedClosingDateLessThanThirteenDaysAway(plannedClosingDate);

  return (
    city &&
    creditScore &&
    downPayment &&
    (hasWaivedEscrow || hasWaivedEscrow === false) &&
    occupancyType &&
    (isSelfEmployed || isSelfEmployed === false) &&
    (isUsCitizen || isUsCitizen === false) &&
    (isVeteran || isVeteran === false) &&
    loanOptions &&
    plannedClosingDate &&
    !isLessThanThirtyDays &&
    price &&
    propertyType &&
    state &&
    street &&
    zip &&
    county
  );
};
